export const USER_INFO = 'cw-user-info'

// socket事件

// 用户发送信息
export const USER_SEND_MESSAGE = 'user-send-message'

// 服务端接收到了用户发送的信息后返回给前端的
export const USER_SEND_MESSAGE_RES = 'user-send-message-res'
